import { ReactNode } from "react";

import * as S from "./styles";

const Container = ({ children, whiteBackground }: { children: ReactNode, whiteBackground?: boolean }) => (
  <S.Container whiteBackground={whiteBackground}>{children}</S.Container>
);

export default Container;
